import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import CONFIG from '../common/config'

const DEFAULT_LANG = CONFIG.DEFAULT_LANG
const LOCALE_KEY_LANG = CONFIG.LOCALE_KEY_LANG

Vue.use(VueI18n)

const messages = {
  en: enLocale,
  zh: zhLocale,
}

const i18n = new VueI18n({
  messages, // set locale messages
  locale: window.localStorage.getItem(LOCALE_KEY_LANG) || DEFAULT_LANG, // set locale
})

export const setup = lang => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY_LANG)
    if (messages[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }

  window.localStorage.setItem(LOCALE_KEY_LANG, lang)
  Object.keys(messages).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  Vue.config.lang = lang
  i18n.locale = lang
}

setup()

VueI18n.prototype.getStorageLang = () => {
  return window.localStorage.getItem(LOCALE_KEY_LANG)
}

export default i18n
